export const customData = {
  list1: [
    {
      title: '清华大学',
      icon: require('@/assets/images/home/custom/logo-1.png'),
    },
    {
      title: '中国人民大学',
      icon: require('@/assets/images/home/custom/logo-2.png'),
    },
    {
      title: '上海交通大学',
      icon: require('@/assets/images/home/custom/logo-3.png'),
    },
    {
      title: '武汉大学',
      icon: require('@/assets/images/home/custom/logo-4.png'),
    },
    {
      title: '山东大学',
      icon: require('@/assets/images/home/custom/logo-5.png'),
    },
    {
      title: '吉林大学',
      icon: require('@/assets/images/home/custom/logo-6.png'),
    },
    {
      title: '福州大学',
      icon: require('@/assets/images/home/custom/logo-7.png'),
    },
    {
      title: '四川大学',
      icon: require('@/assets/images/home/custom/logo-8.png'),
    },
    {
      title: '厦门大学',
      icon: require('@/assets/images/home/custom/logo-9.png'),
    },
    {
      title: '复旦大学',
      icon: require('@/assets/images/home/custom/logo-10.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-11.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-12.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-13.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-14.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-15.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-16.png'),
    },
  ],
  list2: [
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-17.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-18.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-19.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-20.png'),
    },
    {
      title: '北京航空航天大学',
      icon: require('@/assets/images/home/custom/logo-21.png'),
    },
    {
      title: '集美大学',
      icon: require('@/assets/images/home/custom/logo-22.png'),
    },
    {
      title: '云南大学',
      icon: require('@/assets/images/home/custom/logo-23.png'),
    },
    {
      title: '华中科技大学',
      icon: require('@/assets/images/home/custom/logo-24.png'),
    },
    {
      title: '西北工业大学',
      icon: require('@/assets/images/home/custom/logo-25.png'),
    },
    {
      title: '中国地质大学',
      icon: require('@/assets/images/home/custom/logo-26.png'),
    },
    {
      title: '大连理工大学',
      icon: require('@/assets/images/home/custom/logo-27.png'),
    },
    {
      title: '河南职业技术学院',
      icon: require('@/assets/images/home/custom/logo-28.png'),
    },
    {
      title: '浙江金融职业学院',
      icon: require('@/assets/images/home/custom/logo-29.png'),
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom/logo-30.png'),
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom/logo-31.png'),
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom/logo-32.png'),
    },
  ],
  list3: [
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-33.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-34.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-35.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-36.png'),
    },
    {
      title: '北京航空航天大学',
      icon: require('@/assets/images/home/custom/logo-37.png'),
    },
    {
      title: '集美大学',
      icon: require('@/assets/images/home/custom/logo-38.png'),
    },
    {
      title: '云南大学',
      icon: require('@/assets/images/home/custom/logo-39.png'),
    },
    {
      title: '华中科技大学',
      icon: require('@/assets/images/home/custom/logo-40.png'),
    },
    {
      title: '西北工业大学',
      icon: require('@/assets/images/home/custom/logo-41.png'),
    },
    {
      title: '中国地质大学',
      icon: require('@/assets/images/home/custom/logo-42.png'),
    },
    {
      title: '大连理工大学',
      icon: require('@/assets/images/home/custom/logo-43.png'),
    },
    {
      title: '河南职业技术学院',
      icon: require('@/assets/images/home/custom/logo-44.png'),
    },
    {
      title: '浙江金融职业学院',
      icon: require('@/assets/images/home/custom/logo-45.png'),
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom/logo-46.png'),
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom/logo-47.png'),
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom/logo-48.png'),
    },
  ],
  list4: [
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-49.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-50.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-51.png'),
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom/logo-52.png'),
    },
    {
      title: '北京航空航天大学',
      icon: require('@/assets/images/home/custom/logo-53.png'),
    },
    {
      title: '集美大学',
      icon: require('@/assets/images/home/custom/logo-54.png'),
    },
    {
      title: '云南大学',
      icon: require('@/assets/images/home/custom/logo-55.png'),
    },
    {
      title: '华中科技大学',
      icon: require('@/assets/images/home/custom/logo-56.png'),
    },
    {
      title: '西北工业大学',
      icon: require('@/assets/images/home/custom/logo-57.png'),
    },
    {
      title: '中国地质大学',
      icon: require('@/assets/images/home/custom/logo-58.png'),
    },
    {
      title: '大连理工大学',
      icon: require('@/assets/images/home/custom/logo-59.png'),
    },
    {
      title: '河南职业技术学院',
      icon: require('@/assets/images/home/custom/logo-60.png'),
    },
    {
      title: '浙江金融职业学院',
      icon: require('@/assets/images/home/custom/logo-61.png'),
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom/logo-62.png'),
    },
  ],
};

export const customData2 = [
  {
    title: '清华大学',
    icon: require('@/assets/images/home/custom/logo-1.png'),
  },
  {
    title: '中国人民大学',
    icon: require('@/assets/images/home/custom/logo-2.png'),
  },
  {
    title: '上海交通大学',
    icon: require('@/assets/images/home/custom/logo-3.png'),
  },
  {
    title: '武汉大学',
    icon: require('@/assets/images/home/custom/logo-4.png'),
  },
  {
    title: '山东大学',
    icon: require('@/assets/images/home/custom/logo-5.png'),
  },
  {
    title: '吉林大学',
    icon: require('@/assets/images/home/custom/logo-6.png'),
  },
  {
    title: '福州大学',
    icon: require('@/assets/images/home/custom/logo-7.png'),
  },
  {
    title: '四川大学',
    icon: require('@/assets/images/home/custom/logo-8.png'),
  },
  {
    title: '厦门大学',
    icon: require('@/assets/images/home/custom/logo-9.png'),
  },
  {
    title: '复旦大学',
    icon: require('@/assets/images/home/custom/logo-10.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-11.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-12.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-13.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-14.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-15.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-16.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-17.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-18.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-19.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-20.png'),
  },
  {
    title: '北京航空航天大学',
    icon: require('@/assets/images/home/custom/logo-21.png'),
  },
  {
    title: '集美大学',
    icon: require('@/assets/images/home/custom/logo-22.png'),
  },
  {
    title: '云南大学',
    icon: require('@/assets/images/home/custom/logo-23.png'),
  },
  {
    title: '华中科技大学',
    icon: require('@/assets/images/home/custom/logo-24.png'),
  },
  {
    title: '西北工业大学',
    icon: require('@/assets/images/home/custom/logo-25.png'),
  },
  {
    title: '中国地质大学',
    icon: require('@/assets/images/home/custom/logo-26.png'),
  },
  {
    title: '大连理工大学',
    icon: require('@/assets/images/home/custom/logo-27.png'),
  },
  {
    title: '河南职业技术学院',
    icon: require('@/assets/images/home/custom/logo-28.png'),
  },
  {
    title: '浙江金融职业学院',
    icon: require('@/assets/images/home/custom/logo-29.png'),
  },
  {
    title: '南京城市职业学院',
    icon: require('@/assets/images/home/custom/logo-30.png'),
  },
  {
    title: '南京城市职业学院',
    icon: require('@/assets/images/home/custom/logo-31.png'),
  },
  {
    title: '南京城市职业学院',
    icon: require('@/assets/images/home/custom/logo-32.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-33.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-34.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-35.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-36.png'),
  },
  {
    title: '北京航空航天大学',
    icon: require('@/assets/images/home/custom/logo-37.png'),
  },
  {
    title: '集美大学',
    icon: require('@/assets/images/home/custom/logo-38.png'),
  },
  {
    title: '云南大学',
    icon: require('@/assets/images/home/custom/logo-39.png'),
  },
  {
    title: '华中科技大学',
    icon: require('@/assets/images/home/custom/logo-40.png'),
  },
  {
    title: '西北工业大学',
    icon: require('@/assets/images/home/custom/logo-41.png'),
  },
  {
    title: '中国地质大学',
    icon: require('@/assets/images/home/custom/logo-42.png'),
  },
  {
    title: '大连理工大学',
    icon: require('@/assets/images/home/custom/logo-43.png'),
  },
  {
    title: '河南职业技术学院',
    icon: require('@/assets/images/home/custom/logo-44.png'),
  },
  {
    title: '浙江金融职业学院',
    icon: require('@/assets/images/home/custom/logo-45.png'),
  },
  {
    title: '南京城市职业学院',
    icon: require('@/assets/images/home/custom/logo-46.png'),
  },
  {
    title: '南京城市职业学院',
    icon: require('@/assets/images/home/custom/logo-47.png'),
  },
  {
    title: '南京城市职业学院',
    icon: require('@/assets/images/home/custom/logo-48.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-49.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-50.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-51.png'),
  },
  {
    title: '中南大学',
    icon: require('@/assets/images/home/custom/logo-52.png'),
  },
  {
    title: '北京航空航天大学',
    icon: require('@/assets/images/home/custom/logo-53.png'),
  },
  {
    title: '集美大学',
    icon: require('@/assets/images/home/custom/logo-54.png'),
  },
  {
    title: '云南大学',
    icon: require('@/assets/images/home/custom/logo-55.png'),
  },
  {
    title: '华中科技大学',
    icon: require('@/assets/images/home/custom/logo-56.png'),
  },
  {
    title: '西北工业大学',
    icon: require('@/assets/images/home/custom/logo-57.png'),
  },
  {
    title: '中国地质大学',
    icon: require('@/assets/images/home/custom/logo-58.png'),
  },
  {
    title: '大连理工大学',
    icon: require('@/assets/images/home/custom/logo-59.png'),
  },
  {
    title: '河南职业技术学院',
    icon: require('@/assets/images/home/custom/logo-60.png'),
  },
  {
    title: '浙江金融职业学院',
    icon: require('@/assets/images/home/custom/logo-61.png'),
  },
  {
    title: '南京城市职业学院',
    icon: require('@/assets/images/home/custom/logo-62.png'),
  },
];
